<nb-card>
  <nb-card-header>Change Password</nb-card-header>
  <nb-card-body>
    <mat-progress-bar color="accent" mode="indeterminate" *ngIf="isLoading" style="margin-bottom: 15px;"></mat-progress-bar>
    <div class="change-container">
      <div class="change-content">
        <form [formGroup]="form">
          <div class="row">
            <div class="col-12">
              <mat-form-field appearance="legacy" style="width: 100%;" floatLabel="always">
                <mat-label class="title-input-login">Current Password</mat-label>
                <input matInput [type]="!hide ? 'password' : 'text'" formControlName="currentPassword"
                  autocomplete="off" id="inputclave1">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-form-field floatLabel="always" appearance="standard">
                <mat-label>New Password</mat-label>
                <input matInput [type]="!hide ? 'password' : 'text'" formControlName="password">
              </mat-form-field>
              <mat-error class="m-b-5"
                *ngIf="form.get('password').dirty && (form.get('password').hasError('strong') || form.get('password').hasError('minlength') || form.get('password').hasError('maxlength'))">
                password does not meet the security requirements
              </mat-error>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-form-field floatLabel="always" appearance="standard">
                <mat-label>Confirm Password</mat-label>
                <input matInput [type]="!hide ? 'password' : 'text'" formControlName="confirmPassword">
                <mat-icon matSuffix (click)="hide = !hide" style="cursor: pointer;">
                  {{hide ?
                  'visibility_off' :
                  'visibility'}}</mat-icon>
              </mat-form-field>
              <mat-error class="m-b-5"
                *ngIf="form.get('confirmPassword').dirty && form.get('confirmPassword').hasError('NoPassswordMatch')">
                passwords must match
              </mat-error>
            </div>
          </div>
        </form>
      </div>
      <div class="change-info">
        <div class="password-must">
          <span>Your Password must:</span>
          <div class="password-li">
            <li>be 8 to 72 characters long</li>
            <li>not contain your mail</li>
            <li>contain uppercase and lowercase letters</li>
            <li>contain at least one number</li>
            <li>contain at least one special character, e.g., *!_#-@.,$%&+?</li>
            <li>not be commonly used, easily guessed</li>
          </div>
        </div>
      </div>
    </div>


  </nb-card-body>
  <nb-card-footer>
    <div class="modal-footer">
      <button nbButton matRipple ghost status="danger" (click)="dismiss()">Cancel</button>
      <button nbButton matRipple status="primary" #yesButton id="yesButton" [disabled]="form.invalid || isLoading"
        (click)="changePassword()">Change Password</button>
    </div>
  </nb-card-footer>
</nb-card>